import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import ProfileCard from "./components/profileCard";
import CustomTab, {
  TabContainer,
} from "../../../../components/tabs/customTabs";
import BasicCard from "./components/basicCard";
// import EducationCard from "./components/educationCard";
// import ExperienceCard from "./components/experienceCard";
// import DocumentCard from "./components/documentsCard";
// import LeaveCard from "./components/leaveCard";
// import AttendanceCard from "./components/attendanceCard";
import useCommonFetch from "../../../../../hooks/useCommonFetch";
import { getVendorDetail } from "../../../../../services/workspace/inventory.service";
import PurchaseOrderCard from "./components/purchaseOrderCard";
import PurchaseInvoiceCard from "./components/purchaseInvoiceCard";

const items = [
  { label: "Vendor", path: "/inventory/vendor" },
  { label: "Vendor Profile", path: "" },
];

const VendorProfile = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  
  const {
    loading,
    data: vendorData,
    fetchData,
  } = useCommonFetch(getVendorDetail, {
    id: id,
    dataPath: "vendor",
    errorMessage: "Failed to fetch vendor detail!",
    customParams: {
      with: "categories",
    },
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = Number(params.get("tab"));
    if (!isNaN(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [location.search]);

  // ✅ when user clicks tab
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  const heandleFetchData = () => {
    fetchData(
      {
        // additional_info: true,
        // with: "workspace,createdBy,designation,department,educations,experiences,attendances,documents,leaves",
      },
      true,
      id
    );
  };

  const tabs = [
    {
      id: "tab1",
      label: "Overview",
      content: <BasicCard staff={vendorData} loading={loading} heandleFetchData={heandleFetchData} />,
    },
    {
      id: "tab2",
      label: "Purchase Order",
      content: <PurchaseOrderCard id={vendorData.id}/>,
    },
    {
      id: "tab2",
      label: "Purchase Invoice",
      content: <PurchaseInvoiceCard id={vendorData.id}/>,
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={items} />
      <ProfileCard staffData={vendorData} />
      <div className="flex flex-col gap-2 ">
        <CustomTab
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
        <div className="max-h-[calc(100vh-39vh)] h-[calc(100vh-39vh)] overflow-y-auto scrollbar-hidden ">
          <TabContainer tabs={tabs} activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default VendorProfile;
